import currency from 'currency.js'

export const FormatterCurrency = {

  real: value => currency(value, {
    separator: ".",
    decimal: ","
  }).format()

}


// WEBPACK FOOTER //
// ./src/plugins/filters/FormatterCurrency.js